import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { BusinessAccountModel } from '../model';
import { Subject } from 'rxjs';
import { IFormStore } from '../interface';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: BusinessAccountModel };

const initialState: State = { state: 'idle' };

@Injectable()
export class BusinessAccountStore extends ComponentStore<State> implements IFormStore {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<BusinessAccountModel>((_, data) => {
    return {
      state: 'valid',
      data: BusinessAccountModel.fromJson(data),
    };
  });
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));
  readonly submit$ = new Subject<void>();

  constructor() {
    super(initialState);
  }
}
